import React, { Component } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { getFormSyncErrors, reduxForm } from 'redux-form';
import { isMobileOnly } from 'react-device-detect';
import { Base64 } from 'js-base64';
import { getGovIdLink, getPrefillHint } from '../../redux/actions';
import { fetchUser } from '../../services/auth';
import GovIdTypeSelectionForm from './GovIdTypeSelectionForm';
import { clearTimeoutRef } from '../../common/lib/setComponentTimeout';

import '../../../style/index.css';
import './govIdTypeSelection.css';


const constructEnv = () => {
  const { host } = window.location;
  const urlArr = host.split('.');
  if (urlArr && urlArr.length > 0 && urlArr[0].includes('sso')) {
    return urlArr[0];
  }
};

const formName = 'govIdTypeSelection';

const mapStateToProps = (state) => ({
  formErrors: getFormSyncErrors(formName)(state),
  govIdLink: state.selectGovIdTypeReducer.govIdLink,
  govIdLinkError: state.selectGovIdTypeReducer.govIdLinkError,
  prefillRedirectUrl: state.selectGovIdTypeReducer.prefillRedirectUrl,
  prefillError: state.selectGovIdTypeReducer.prefillError,
});

const mapDispatchToProps = {
  getGovIdLink,
  getPrefillHint,
};

@connect(mapStateToProps, mapDispatchToProps)
class GovIdTypeSelectionView extends Component {
  constructor(props) {
    super(props);
    this.handleGovIdTypeSelectionSubmit = this.handleGovIdTypeSelectionSubmit.bind(this);
    this.formRef = React.createRef();
    this.timeoutRef = React.createRef();
    this.state = { formSubmissionError: false };
  }

  componentWillUnmount() {
    clearTimeoutRef(this.timeoutRef);
  }

  componentDidUpdate(prevProps) {
    const {
      govIdLink,
      govIdLinkError,
      prefillRedirectUrl,
      prefillError,
    } = this.props;
    // Redirect when link is received (desktop flow)
    if (govIdLink && govIdLink !== prevProps.govIdLink) {
      window.location.replace(govIdLink);
    }
    // Handle govIdLink error
    if (govIdLinkError && govIdLinkError !== prevProps.govIdLinkError) {
      this.setState({ formSubmissionError: true });
    }
    // Redirect when prefill JWT is received (incode/mobile flow)
    if (prefillRedirectUrl && prefillRedirectUrl !== prevProps.prefillRedirectUrl) {
      window.location.replace(prefillRedirectUrl);
    }
    // Handle prefill error
    if (prefillError && prefillError !== prevProps.prefillError) {
      this.setState({ formSubmissionError: true });
    }
  }

  handleGovIdTypeSelectionSubmit(e, flowType) {
    e.preventDefault();
    e.stopPropagation();
    const { getGovIdLink, getPrefillHint } = this.props;
    const queryParams = queryString.parse(window.location.search);
    const callbackUri = _.get(queryParams, 'callbackUri', false);

    const clientId = _.get(queryParams, 'clientId', false);
    const user = fetchUser();
    const accessToken = _.get(user, 'accessToken', false);
    const ssoEnv = __CONFIG__.env;
    const redirectUri = __CONFIG__.iddwGovIdRedirectUri;
    const isStageOrProd = ssoEnv === 'production' || ssoEnv === 'stage';
    const baseUrl = `https://${isStageOrProd ? '' : 'preprod.'}verify.nylservices.net`;
    const path = `${isStageOrProd ? 'prod' : 'preprod'}-axn/axn/oauth2/authorize`;
    const iddwClientId = __CONFIG__.iddwIncodeClientId;

    const stateQueryParamObj = {
      accessToken,
      callbackUri,
      clientId,
    };

    if (flowType === 'mobile' && !isMobileOnly) {
      stateQueryParamObj.govIdType = 'incode-mobile';
    } else if (flowType === 'mobile' && isMobileOnly) {
      stateQueryParamObj.govIdType = 'incode-desktop';
    } else if (flowType === 'desktop') {
      // For desktop/browser flow, use the get-link endpoint
      const govIdTypeForLink = 'usdl-desktop';

      if (govIdTypeForLink) {
        // Use the get-link endpoint for browser flow
        getGovIdLink(govIdTypeForLink, 'browser');
        return;
      }
    }

    if (iddwClientId) {
      const stateQueryParamStr = JSON.stringify(stateQueryParamObj);
      const encodedStateQueryParam = encodeURIComponent(Base64.encode(stateQueryParamStr));
      getPrefillHint({
        baseUrl,
        path,
        redirectUri,
        iddwClientId,
        encodedStateQueryParam,
      });
    } else {
      this.setState({ formSubmissionError: true });
    }
  }

  render() {
    const { formSubmissionError } = this.state;
    return (
      <div className="login row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <GovIdTypeSelectionForm
            submitFormFn={this.handleGovIdTypeSelectionSubmit}
            formSubmissionError={formSubmissionError}
          />
        </div>
      </div>
    );
  }
}

export default reduxForm({ form: formName })(GovIdTypeSelectionView);
